import React from "react";

const ShuttleWithShadow = ({ ...props }) => {
  return (
    <svg
      width={65}
      height={84}
      viewBox="0 0 65 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#prefix__filter0_d)">
        <circle cx={32.5} cy={13.323} r={13.323} fill="#fff" />
        <path
          d="M4 65.795l17.613-51.854 7.622 1.237-4.429 50.617-10.815 9.381L4 65.796zM61 65.795L43.387 13.941l-7.622 1.237 4.429 50.617 10.815 9.381L61 65.796z"
          fill="#fff"
        />
        <path
          d="M23.941 66.902l3.16-45.373h10.887l3.424 45.373-8.955 8.274-8.516-8.274z"
          fill="#fff"
        />
        <path
          d="M25.706 59.438l2.458-39.85h8.467l2.663 39.85-6.965 7.268-6.623-7.268z"
          fill="#FAFAFA"
        />
        <circle cx={30.559} cy={9.265} r={6.618} fill="#FAFAFA" />
        <circle cx={41.324} cy={13.324} r={2.206} fill="#FAFAFA" />
        <path fill="#1D3557" d="M19.177 13.412h26.647V21H19.177z" />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d"
          x={0}
          y={0}
          width={65}
          height={83.176}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default ShuttleWithShadow;
